import { createStore } from '@ngneat/elf'
import { addEntities, withEntities } from '@ngneat/elf-entities'
import { Injectable } from '@angular/core'
import { Plan } from '../models/plan'
import { PlanCreationDao } from '../services/dao/plan-creation.dao'
import { PlanCreateCommandParams } from '../../generated/efp-api'
import {
  ApplicationInsightsService,
  ApplicationInsightsStates,
} from '../services/applicationInsights.service'
import { Doka360ProjectSelectorService } from '../services/doka360-project-selector.service'

export const planStore = createStore({ name: 'plan' }, withEntities<Plan>())

@Injectable({
  providedIn: 'root',
})
export class PlanCreationRepository {
  constructor(
    private readonly planCreationDao: PlanCreationDao,
    private readonly appInsightsService: ApplicationInsightsService,
    private readonly doka360ProjectSelectorService: Doka360ProjectSelectorService
  ) {}

  public async createPlan(params: PlanCreateCommandParams): Promise<Plan> {
    const doka360ProjectUid = this.doka360ProjectSelectorService.getCurrentDoka360ProjectUid()
    params.doka360ProjectUid = doka360ProjectUid
    const newPlan = await this.planCreationDao.createPlan(params)

    if (newPlan) {
      planStore.update(addEntities(newPlan))
      this.appInsightsService.addUserEvent(ApplicationInsightsStates.PLAN_CREATED, newPlan.id)
    }
    return newPlan
  }
}
